const Locales = {
  'cs': {
    icon: '🇨🇿',
    title: 'locales.cs',
    lang: 'cs'
  },
  'en': {
    icon: '🇬🇧',
    title: 'locales.en',
    lang: 'en'
  },
  'pl': {
    icon: '🇵🇱',
    title: 'locales.pl',
    lang: 'pl'
  }
}

export default Locales